<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-5">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div>
          <div class="page-title">Request Interns</div>
          <div class="page-subtitle">Find the perfect interns for your organization.</div>
        </div>
        <v-btn
          color="#00A63E"
          variant="flat"
          class="text-white"
          prepend-icon="mdi-plus"
          rounded="lg"
          size="large"
          @click="addInternRequest"
        >
          Add Intern Request
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card flat rounded="xl" class="table-card">
          <div class="d-flex align-center justify-space-between pa-4">
            <div>
              <div class="card-title">Intern Requests</div>
              <v-chip size="x-small" color="#00A63E" variant="tonal" class="mt-1">{{ tabledata.length }} records</v-chip>
            </div>
            <v-text-field
              v-model="search"
              placeholder="Search..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              style="max-width: 280px;"
            />
          </div>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="tabledata"
            :search="search"
            :loading="loading"
            hover
            class="rounded-b-xl"
          >
            <template v-slot:[`item.pg`]="{ item }">
              <v-chip
                v-for="(i, idx) in getProgramNames(item.programs)"
                :key="idx"
                size="small"
                variant="tonal"
                color="#00A63E"
                class="px-2 mx-1"
                >{{ i }}</v-chip
              >
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip size="small" variant="tonal" v-if="item.status == 1" color="warning">For Approval</v-chip>
              <v-chip size="small" variant="tonal" v-if="item.status == 2" color="success">Granted</v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                color="#00A63E"
                variant="tonal"
                size="small"
                rounded="lg"
                @click="viewItem(item)"
              >
                View
              </v-btn>
            </template>
            <template v-slot:no-data>
              <div class="text-center py-8">
                <v-icon size="40" color="grey-lighten-1">mdi-clipboard-list-outline</v-icon>
                <div class="text-grey mt-2" style="font-size: 13px;">No intern requests found</div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CompanyRequestInternDialog :data="itemData" :action="action" />

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import CompanyRequestInternDialog from "../Dialogs/Forms/CompanyRequestInternDialog.vue";

export default {
  components: {
    CompanyRequestInternDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",

    size: 200,
    headers: [
      { title: "Number of Interns", value: "num_interns", align: "start" },
      { title: "Program", value: "pg", align: "start" },
      { title: "Status", value: "status", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    skillsList: [],
    selectedSkills: [],
    programs_for: [],
    programSelected: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    programs: [],
    num_interns: null,
    showStudentMatching: false,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    tabledata: [],
    creds: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.loadProgramsTied();
    this.initialize();
    eventBus.on("closeCompanyInternRequestDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeCompanyInternRequestDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.axiosCall("/organization/loadInternRequest", "GET").then((res) => {
        if (res) {
          console.log("sds  ", res.data);
          this.tabledata = res.data;
        }
      });
    },

    loadProgramsTied() {
      this.axiosCall("/organization/getMyProgramsTied", "GET").then((res) => {
        if (res) {
          console.log("ORGS", res.data);
          this.programs = res.data;
        }
      });
    },

    getProgramNames(programs) {
      let arr = [];
      for (let i = 0; i < programs.length; i++) {
        for (let j = 0; j < this.programs.length; j++) {
          if (programs[i] == this.programs[j].id) {
            arr.push(this.programs[j].abbr);
          }
        }
      }
      return arr;
    },

    addInternRequest() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    loadSkills() {
      let progs = JSON.stringify(this.programSelected);
      console.log("PROGS", progs);
      if (this.programSelected.length > 0) {
        this.axiosCall(
          "/skill-assessement/getSkillCategoryByProgram/" + progs,
          "GET",
        ).then((res) => {
          if (res.data) {
            console.log(res.data);
            this.skillsList = res.data;
          }
        });
      }
    },

    async save() {
      let validate = await this.$refs.InternRequestForm.validate();
      if (validate.valid) {
        if (this.programSelected.length == 0) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please select program.";
        } else {
          let data = {
            programSelected: JSON.stringify(this.programSelected),
            num_interns: this.num_interns,
            skills: JSON.stringify(this.selectedSkills),
          };

          this.axiosCall("/organization/add-intern-request", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.showStudentMatching = true;
              } else if (res.data.status == 400) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },

    viewMatching(item) {
      console.log(item);
      this.expandTab1 = true;
      this.showStudentMatching = true;

      this.axiosCall("/student/find-intern/byRequest/" + item.id, "GET").then(
        (res) => {
          console.log(res.data);
        },
      );
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.5px;
}
.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-top: 2px;
}
.table-card {
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}
</style>
